export const homeDeliveryInfoAdapter = (data) => {
	return [
		{
			key: data?._id,
			type_house: data?.info?.type_house || '-',
			phone: data?.info?.phone || '-',
			reference: data?.info?.reference || '-',
			street: data?.info?.street + ' ' + data?.info?.street_number || '-',
			commune: data?.info?.commune || '-',
			region: data?.info?.region || '-',
			dpto: data?.info?.dpto || '-',

		
		},
	];
};
